import { acquireToken } from '@alixpartners/ui-utils';
import { decodeApplicationUser } from 'utils/AppInitializer/application-user';
import { actions } from '../applicationUserReducer';
import { AppDispatch, GetState } from '../store';

export const acquireUserThunk =
  () => async (dispatch: AppDispatch, _getState: GetState) => {
    dispatch(actions.fetching());
    try {
      const token = await acquireToken();
      const user = decodeApplicationUser(token);

      //!!! important !!! for debug purposes only
      // do not put the next line to the release
      // const user = decodeApplicationUser_as_TestClient(token);

      dispatch(actions.done(user));
      return user;
    } catch (e) {
      console.error(e);
      dispatch(actions.error({ message: 'Could not decode user access token.' }));
    }
  };
